"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProposalError;
(function (ProposalError) {
    ProposalError["database_operation_failed"] = "database_operation_failed";
    ProposalError["chain_operation_failed"] = "chain_operation_failed";
    ProposalError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
    ProposalError["account_does_not_exist"] = "account_does_not_exist";
    ProposalError["account_fetch_failed"] = "account_fetch_failed";
    ProposalError["transfer_sender_account_does_not_exist"] = "transfer_sender_account_does_not_exist";
    ProposalError["transfer_receiver_account_does_not_exist"] = "transfer_receiver_account_does_not_exist";
    ProposalError["asset_not_found"] = "asset_not_found";
    ProposalError["propose_object_not_found"] = "propose_object_not_found";
    ProposalError["api_connection_failed"] = "api_connection_failed";
    ProposalError["syntactic_error"] = "syntactic_error";
    ProposalError["invalid_parameters"] = "invalid_parameters";
})(ProposalError = exports.ProposalError || (exports.ProposalError = {}));
var ProposalParameters = /** @class */ (function () {
    function ProposalParameters() {
        this.current_fees = null;
        this.block_interval = null;
        this.maintenance_interval = null;
        this.maintenance_skip_slots = null;
        this.miner_proposal_review_period = null;
        this.maximum_transaction_size = null;
        this.maximum_block_size = null;
        this.maximum_time_until_expiration = null;
        this.maximum_proposal_lifetime = null;
        this.maximum_asset_feed_publishers = null;
        this.maximum_miner_count = null;
        this.maximum_authority_membership = null;
        this.cashback_vesting_period_seconds = null;
        this.cashback_vesting_threshold = null;
        this.max_predicate_opcode = null;
        this.max_authority_depth = null;
        this.extensions = null;
    }
    return ProposalParameters;
}());
exports.ProposalParameters = ProposalParameters;
var ProposalCreateParameters = /** @class */ (function () {
    function ProposalCreateParameters() {
        this.fee_paying_account = '';
        this.expiration_time = '';
        this.review_period_seconds = null;
    }
    return ProposalCreateParameters;
}());
exports.ProposalCreateParameters = ProposalCreateParameters;
var FeesParameters = /** @class */ (function () {
    function FeesParameters() {
        this.transfer = null; // 0
        this.account_create = null;
        this.account_update = null;
        this.asset_create = null;
        this.asset_update = null;
        this.asset_publish_feed = null; // 5
        this.miner_create = null;
        this.miner_update = null;
        this.miner_update_global_parameters = null;
        this.proposal_create = null;
        this.proposal_update = null; // 10
        this.proposal_delete = null;
        this.withdraw_permission_create = null;
        this.withdraw_permission_update = null;
        this.withdraw_permission_claim = null;
        this.withdraw_permission_delete = null; // 15
        this.vesting_balance_create = null;
        this.vesting_balance_withdraw = null;
        this.custom = null;
        this.assert = null;
        this.content_submit = null; // 20
        this.request_to_buy = null;
        this.leave_rating_and_comment = null;
        this.ready_to_publish = null;
        this.proof_of_custody = null;
        this.deliver_keys = null; // 25
        this.subscribe = null;
        this.subscribe_by_author = null;
        this.automatic_renewal_of_subscription = null;
        this.report_stats = null;
        this.set_publishing_manager = null; // 30
        this.set_publishing_right = null;
        this.content_cancellation = null;
        this.asset_fund_pools_operation = null;
        this.asset_reserve_operation = null;
        this.asset_claim_fees_operation = null; // 35
        this.update_user_issued_asset = null;
        this.update_monitored_asset_operation = null;
        this.ready_to_publish2 = null;
        this.transfer2 = null;
        this.disallow_automatic_renewal_of_subscription = null; // 40
        this.return_escrow_submission = null;
        this.return_escrow_buying = null;
        this.pay_seeder = null;
        this.finish_buying = null;
        this.renewal_of_subscription = null; // 45
    }
    return FeesParameters;
}());
exports.FeesParameters = FeesParameters;
var DeltaParameters = /** @class */ (function () {
    function DeltaParameters() {
    }
    return DeltaParameters;
}());
exports.DeltaParameters = DeltaParameters;
//# sourceMappingURL=proposal.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/proposal.js
// module id = 95
// module chunks = 0